import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { AdminSubNav } from '@/components/shell/AdminSubNav'
import { LearningsPage } from '@/features/learnings/LearningsPage'

function AdminLearnings() {
  const { id } = Route.useSearch()
  return (
    <AdminGuard>
      <AdminSubNav />
      <LearningsPage selectedId={id} />
    </AdminGuard>
  )
}

export const Route = createFileRoute('/admin/learnings')({
  validateSearch: (search: Record<string, unknown>): { id?: string } => (typeof search.id === 'string' ? { id: search.id } : {}),
  component: AdminLearnings
})
